export const PlainTextLang = 'plaintext';
